import api from "@/api"

export default {
    // 하위 게시글 목록 조회
    getRecentSubArticleList(menuId: number, comCode: string, personCode: string, 
                            page: number, pageSize: number, searchType: number, searchText: string){
        return api.get({
            url: `/Portal/Article/api/subrecentarticlelist?MenuId=${menuId}&ComCode=${comCode}&PersonCode=${personCode}&Page=${page}&ItemsPerPage=${pageSize}&SearchField=${searchType}&SearchText=${searchText}`,
        })
    },
}